<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useLocale } from 'vuetify'
import { useAppStore } from '@/stores/app'
import i18n from '@/plugins/i18n'
import AcademicYearWelcomeModal from '@/components/app/AcademicYearWelcomeModal.vue'
import LeaveWarningModal from '@/components/app/LeaveWarningModal.vue'
import PreviewBar from '@/components/app/PreviewBar.vue'
import QuickHelpDrawer from '@/components/app/QuickHelpDrawer.vue'

const { t } = useI18n()

const appStore = useAppStore()
const { snackbar } = storeToRefs(appStore)
const snackbarActive = ref(false)

const { current } = useLocale()

watch(
  () => i18n.global.locale.value,
  newLocale => {
    // Sync Vuetify locale with vue-i18n locale
    current.value = newLocale
  },
  { immediate: true },
)

watch(() => appStore.academicYearWelcomeModal.shouldDisplay, shouldDisplay => {
  appStore.academicYearWelcomeModal.active = shouldDisplay
})

watch(snackbar, () => {
  snackbarActive.value = true
})
</script>

<template>
  <VLocaleProvider>
    <VApp>
      <PreviewBar />
      <RouterView />
      <VSnackbar
        v-model="snackbarActive"
        :color="snackbar.colour"
        :multi-line="snackbar.multiLine"
        :timeout="snackbar.timeout"
        :variant="snackbar.variant"
      >
        <div
          v-dompurify-html="snackbar.text"
          class="snackbar-text"
        />
        <template #actions>
          <VBtn
            color="white"
            class="ma-2"
            @click="snackbarActive = false"
          >
            {{ t('actions.close') }}
          </VBtn>
        </template>
      </VSnackbar>
      <LeaveWarningModal />
      <QuickHelpDrawer />
      <AcademicYearWelcomeModal />
    </VApp>
  </VLocaleProvider>
</template>

<style lang="scss">
.snackbar-text a {
  font-weight: bold;
  color: white !important;
}
</style>
